export const capitalizeFirstLetter = (word: string) => {
  return word.charAt(0).toUpperCase() + word.slice(1);
};

export const cutLongWords = (value: string, size: number) => {
  return value.length > size ? `${value.slice(0, size)}...` : value;
};

// Slug rules (questions & options): lowercase letters, numbers and hyphens only,
// must start with a letter, max 50 characters. This produces a best-effort
// suggestion from a label; the user can still edit it before saving.
export const SLUG_MAX_LENGTH = 50;

export const slugify = (value: string): string => {
  const slug = value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '') // strip accents/diacritics
    .replace(/[^a-z0-9\s-]/g, '') // strip invalid characters
    .trim()
    .replace(/[\s_]+/g, '-') // spaces/underscores -> hyphens
    .replace(/-+/g, '-') // collapse consecutive hyphens
    .replace(/^[^a-z]+/, '') // must start with a letter
    .replace(/-+$/, ''); // no trailing hyphen

  return slug.slice(0, SLUG_MAX_LENGTH);
};

// Mirrors the backend slug validation so the admin form can validate before save.
export const isValidSlug = (value: string): boolean => {
  return /^[a-z][a-z0-9-]*$/.test(value) && value.length <= SLUG_MAX_LENGTH;
};
